import React from 'react';
import { ReactComponent as CloseIcon } from '@src/assets/icons/close.svg';
import { ArcIconButton, ArcStack, ArcText } from '@src/core/ui';
import { useDispatch } from 'react-redux';
import { setSelectedZone } from '@src/features/zones/redux';

interface ZonePopupWrapperProps {
  title?: string;
  error?: boolean;
  children?: React.ReactNode;
}

const ZonePopupWrapper: React.FC<ZonePopupWrapperProps> = (props) => {
  const { title, error, children } = props;

  const dispatch = useDispatch();
  const onRemoveZone = () => dispatch(setSelectedZone(null));

  return (
    <ArcStack 
      p={2} 
      width='100%' 
      maxWidth={400}
      minWidth={400}
      borderRadius={1}
      position='absolute'
      left={485}
      top={45}
      zIndex={100}
      bgcolor={error ? 'rose.main' : 'background.paper'}>

      <ArcStack 
        spacing={2}
        direction='row' 
        alignItems='center' 
        justifyContent='space-between'>
        <ArcText.h6 fontWeight={500}> {title} </ArcText.h6>
        <ArcIconButton onClick={onRemoveZone}> <CloseIcon /> </ArcIconButton>
      </ArcStack>

      {children}
    </ArcStack>
  );
};

export default ZonePopupWrapper;
